import { Link, usePage } from "@inertiajs/react";
import { useTranslation } from "react-i18next";
import { ArrowLeft } from "lucide-react";
import { isCollectionPath, navigationSection } from "@/lib/navigation";
import { useCollectionOrigin } from "@/hooks/use-collection-origin";

export function WorkspaceNavigation() {
  const {
    url,
    props: { auth, notification_parent },
  } = usePage();
  const { t } = useTranslation();
  const { href: origin, restoreScroll } = useCollectionOrigin();
  const location = auth.location?.id;
  const section = navigationSection(
    url,
    location,
    notification_parent?.section,
  );
  if (!location) return null;
  const nested =
    !isCollectionPath(url) &&
    ["jobs", "requests", "customers", "inventory"].includes(section || "");
  if (!nested) return null;
  return (
    <div className="flex flex-wrap items-center justify-between gap-3 border-b px-page py-3">
      {nested && origin && (
        <Link
          className="inline-flex min-h-11 items-center gap-2 rounded-sm text-sm underline underline-offset-4 focus-visible:ring-2 focus-visible:ring-ring"
          href={origin}
          preserveScroll
          onSuccess={restoreScroll}
        >
          <ArrowLeft className="size-4" aria-hidden="true" />
          {t("navigation.back_to_collection")}
        </Link>
      )}
    </div>
  );
}
